export function hexToRgb(hex) {
  let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) {
    result = /^#?([a-f\d]{1})([a-f\d]{1})([a-f\d]{1})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1] + result[1], 16),
      g: parseInt(result[2] + result[2], 16),
      b: parseInt(result[3] + result[3], 16)
    } : '';
  }
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : '';
}

export function rgbToHex(rgb) {
  function componentToHex(c) {
    const hex = c.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
  }

  return `#${componentToHex(rgb.r)}${componentToHex(rgb.g)}${componentToHex(rgb.b)}`;
}

// / For a given rbg background, return the suggested hex foreground
export function getHexTextColorRGB(backgroundColor) {
  const brightness = ((backgroundColor.r * 299) + (backgroundColor.g * 587) + (backgroundColor.b * 114)) / 1000;
  return brightness < 123 ? '#fff' : '#000';
}

// / For a given hex background, return the suggested hex foreground
export function getHexTextColorHex(backgroundColor) {
  return getHexTextColorRGB(hexToRgb(backgroundColor));
}

export function getHexToRgba(hex, alpha) {
  const color = hexToRgb(hex);
  return `rgba(${color.r}, ${color.g}, ${color.b}, ${alpha})`;
}
